<div class="modal-header m-0">
  <h4 class="modal-title pull-left">
    {{ "caeImportPopup.title" | translate }}
  </h4>
</div>

<div class="modal-body pt-0">
  <p>
    {{
      "caeImportPopup.label.there_already_exists"
        | translate: { "0": projectGroupName }
    }}
  </p>
  <p>
    {{ "caeImportPopup.label.list_header" | translate }}
  </p>
  <table>
    <tr *ngFor="let project of projectNamesAndStates">
      <td>{{ project.name }}</td>
      <td>({{ project.status | translate }})</td>
    </tr>
  </table>
</div>

<div class="modal-footer">
  <div class="px-3 d-flex gap-2 justify-content-end">
    <button
      #cancelButton
      type="button"
      class="btn btn-secondary btn-cancel"
      (click)="cancel()"
      (keyup.enter)="cancel()"
      (keydown.enter)="$event.preventDefault()"
      data-testid="alert-cancel"
      id="alert-cancel"
    >
      {{ "global.label.cancel" | translate }}
    </button>
    <button
      #createButton
      type="button"
      class="btn btn-primary btn-forward"
      (click)="createNew()"
      (keyup.enter)="createNew()"
      (keydown.enter)="$event.preventDefault()"
      id="alert-yes"
    >
      {{ "caeImportPopup.button.create_new" | translate }}
    </button>
    <button
      #updateRef
      type="button"
      class="btn btn-primary btn-forward"
      (click)="update()"
      (keyup.enter)="update()"
      (keydown.enter)="$event.preventDefault()"
      data-testid="alert-confirm"
      id="step_forward"
    >
      {{ "caeImportPopup.button.update" | translate }}
    </button>
  </div>
</div>
